import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraSelect } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { Link } from 'react-router-dom';
import { EconomicsFigures } from './EconomicsFigures';
import { useOrganizationLabel } from './LandscapeOrganizationsField';
/** Narrow by Landscape and by organization scope; the two filters are independent. */ export function filterLandscapes(landscapes, landscapeFilter, organizationFilter) {
    return landscapes.filter((l)=>(!landscapeFilter || l.id === landscapeFilter) && (!organizationFilter || l.organizationIds.includes(organizationFilter)));
}
export function LandscapeList({ landscapes, landscapeFilter, organizationFilter, listSearch, economics, onLandscapeFilter, onOrganizationFilter }) {
    const labelOf = useOrganizationLabel();
    const organizations = [
        ...new Set(landscapes.flatMap((l)=>l.organizationIds))
    ].sort((a, b)=>labelOf(a).label.localeCompare(labelOf(b).label));
    const figuresById = new Map((economics ?? []).map((e)=>[
            e.landscapeId,
            e.figures
        ]));
    const visible = filterLandscapes(landscapes, landscapeFilter, organizationFilter);
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-wrap items-center gap-2",
                children: [
                    /*#__PURE__*/ _jsxs(SpecraSelect, {
                        size: "sm",
                        value: landscapeFilter,
                        onChange: (e)=>onLandscapeFilter(e.target.value),
                        "aria-label": "Landscape",
                        "data-testid": Testids.landscapes.landscapeFilter,
                        children: [
                            /*#__PURE__*/ _jsx("option", {
                                value: "",
                                children: "All Landscapes"
                            }),
                            landscapes.map((l)=>/*#__PURE__*/ _jsx("option", {
                                    value: l.id,
                                    children: l.name
                                }, l.id))
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(SpecraSelect, {
                        size: "sm",
                        value: organizationFilter,
                        onChange: (e)=>onOrganizationFilter(e.target.value),
                        "aria-label": "Organization scope",
                        "data-testid": Testids.landscapes.organizationFilter,
                        children: [
                            /*#__PURE__*/ _jsx("option", {
                                value: "",
                                children: "All organizations"
                            }),
                            organizations.map((o)=>{
                                const { label, matched } = labelOf(o);
                                return /*#__PURE__*/ _jsx("option", {
                                    value: o,
                                    children: matched ? label : `${label} (unmatched)`
                                }, o);
                            })
                        ]
                    })
                ]
            }),
            visible.length === 0 && /*#__PURE__*/ _jsx("p", {
                className: "text-sm text-muted-foreground",
                "data-testid": Testids.landscapes.listEmpty,
                children: "No Landscapes match."
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "divide-y divide-border",
                children: visible.map((l)=>/*#__PURE__*/ _jsxs("li", {
                        className: "space-y-2 py-2",
                        "data-testid": Testids.landscapes.listRow,
                        "data-landscape-id": l.id,
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center justify-between gap-2",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsx(Link, {
                                                to: `/landscapes/${l.id}`,
                                                state: {
                                                    listSearch
                                                },
                                                className: "text-sm font-medium hover:underline",
                                                children: l.name
                                            }),
                                            l.scope && /*#__PURE__*/ _jsx("div", {
                                                className: "text-xs text-muted-foreground",
                                                children: l.scope
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "text-sm text-muted-foreground",
                                        "data-testid": Testids.landscapes.memberCount,
                                        children: [
                                            l.activeMemberCount,
                                            " active"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(LandscapeRowEconomics, {
                                id: l.id,
                                figures: figuresById.get(l.id)
                            })
                        ]
                    }, l.id))
            })
        ]
    });
}
function LandscapeRowEconomics({ id, figures }) {
    if (!figures) return null;
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": Testids.portfolio.landscape,
        "data-landscape-id": id,
        children: /*#__PURE__*/ _jsx(EconomicsFigures, {
            figures: figures
        })
    });
}
